import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App";
import "./index.css";
import { registerSW } from "virtual:pwa-register";

// Registra el service worker que deja instalar la app y precachea el
// "cascarón" (JS/CSS/HTML) para que abra incluso sin internet. `autoUpdate`
// hace que, cuando hay una versión nueva desplegada, se actualice sola en
// segundo plano sin pedirle nada al usuario.
//
// onNeedRefresh: se dispara cuando ya hay una versión nueva instalada de
// fondo (gracias a clientsClaim/skipWaiting en vite.config.ts) — se recarga
// la página sola para que la pestaña tome esa versión nueva, en vez de
// quedarse corriendo el JS viejo hasta que el usuario la cierre y reabra
// (esto era justo lo que causaba la pantalla en blanco ocasional).
const actualizarSW = registerSW({
  immediate: true,
  onNeedRefresh() {
    actualizarSW(true);
  },
  onRegisteredSW(_url, registro) {
    // Revisa cada hora si hay una versión nueva, por si la pestaña se queda
    // abierta mucho tiempo sin recargar sola.
    if (registro) {
      setInterval(() => registro.update(), 60 * 60 * 1000);
    }
  },
});

ReactDOM.createRoot(document.getElementById("root")!).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
